// extracted by mini-css-extract-plugin
export default {"fkBlue":"#0063be","fkGrey":"#efefef","fkDarkGrey":"#636363","fkWhite":"#fff","paragraph":"Footer_paragraph__bXMbn"};